module.exports = __webpack_public_path__ + "static/img/banner4.e59dd89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner4.jpg
// module id = FjYi
// module chunks = 1